import { Text } from '@chakra-ui/react';
import { useActiveSession } from '@texas/hooks/useSession';
import { formatPreferredWeight } from '@texas/resources/weightUnits';
import { useTranslation } from 'react-i18next';

interface WeightDisplayProps {
  value?: number | null;
  conversionOnly?: boolean;
}

export function WeightDisplay({
  value,
  conversionOnly = false,
}: WeightDisplayProps) {
  const { currentUser } = useActiveSession();
  const { i18n } = useTranslation();
  const preferred = formatPreferredWeight(
    value,
    currentUser.preferredWeightUnit,
    i18n.language,
  );

  if (value == null || !Number.isFinite(value) || value < 0) return null;
  if (conversionOnly && !preferred) return null;

  return (
    <Text as="span">
      {!conversionOnly && `${value} kg`}
      {preferred && `${conversionOnly ? '' : ' '}(${preferred})`}
    </Text>
  );
}
